/* eslint-disable no-param-reassign */
class RemoveLineItemButton extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const cartItems = this.closest("[data-cart-items]");
    const line = this.dataset.removeLineItemButton;
    const quantity = 0;

    event.preventDefault();

    cartItems.updateQuantity(line, quantity);
  }
}

customElements.define("remove-line-item-button", RemoveLineItemButton, {
  extends: "button",
});

class CartItems extends HTMLFormElement {
  sectionsToRender = [
    {
      name: "cart-count",
      selector: "[data-cart-count]",
    },
    {
      name: "mini-cart",
      selector: "[data-mini-cart]",
    },
    {
      name: "mini-cart",
      selector: ".drawer__footer",
    },
    {
      name: "cart",
      selector: "[data-cart]",
    },
  ];

  constructor() {
    super();

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value, 10),
      0
    );

    this.confirmRegistryAttributes();

    this.debouncedChangeHandler = WYATT.debounce((event) => {
      this.handleChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedChangeHandler.bind(this));
  }

  confirmRegistryAttributes() {
    const shouldRemove = this.dataset?.registryRemove
      ? JSON.parse(this.dataset.registryRemove)
      : false;
    const attributes = {};

    if (!shouldRemove) {
      return;
    }

    this.dataset.registryAttributes.split(",").forEach((attribute) => {
      if (attribute) {
        attributes[attribute] = null;
      }
    });

    WYATT.asyncRequest(`${WYATT.routes.cart_update_url}.js`, {
      ...WYATT.fetchConfig(),
      ...{ body: JSON.stringify({ attributes }) },
    });
  }

  handleChange(event) {
    this.updateQuantity(
      event.target.dataset.lineItemIndex,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionNames() {
    return [...new Set(this.sectionsToRender.map((section) => section.name))];
  }

  showLoading(line) {
    const lineItems = document.querySelectorAll(`[data-line-item-${line}]`);

    lineItems.forEach((lineItem) => {
      lineItem.classList.add("line-item--updating");
    });
  }

  hideLoading() {
    const updatingLineItems = document.querySelectorAll(".line-item--updating");

    updatingLineItems.forEach((lineItem) => {
      lineItem.classList.remove("line-item--updating");
    });
  }

  async updateQuantity(line, quantity, name) {
    const body = {
      line,
      quantity,
      sections: this.getSectionNames(),
      sections_url: window.location.pathname,
    };
    const options = {
      ...WYATT.fetchConfig(),
      ...{ body: JSON.stringify(body) },
    };

    this.showLoading(line);

    const response = await WYATT.asyncRequest(
      WYATT.routes.cart_change_url,
      options
    );

    if (response) {
      this.handleSuccessfulUpdate(response, line, name);
    }

    this.hideLoading();
  }

  handleSuccessfulUpdate(state, line, name) {
    const parsedState = JSON.parse(state);

    this.sectionsToRender.forEach((section) =>
      WYATT.replaceDOM(parsedState.sections[section.name], section.selector)
    );

    this.handleQuantityErrors(line, parsedState.item_count);
    this.updateFocusStates(line, name);
  }

  updateFocusStates(line, name) {
    const lineItems = document.querySelectorAll(`[data-line-item-${line}]`);

    lineItems.forEach((lineItem) => {
      if (lineItem.querySelector(`[name="${name}"]`)) {
        lineItem.querySelector(`[name="${name}"]`).focus();
      }
    });
  }

  handleQuantityErrors(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemErrorPlaceholders = document.querySelectorAll(
        `[data-line-item-error-${line}]`
      );

      lineItemErrorPlaceholders.forEach((placeholder) => {
        placeholder.classList.remove("hidden");
      });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define("cart-items", CartItems, {
  extends: "form",
});
